import { LeadResponse } from '../services/responses/lead.response';
import { BoardColumnWithLeads } from '../services/responses/board-column.response';
import { ScheduleFilter, matchesScheduleFilter } from './crm-schedule-filter';
import { matchesOwner } from './crm-owner-filter';
import { matchesTag } from './crm-tag-filter';

/// Os filtros da barra do quadro. Nulo e vazio são "todos".
export interface LeadFilters {
    searchTerm: string;
    statusFilterId: string | null;
    ownerFilter: string | null;
    tagFilter: string | null;
    scheduleFilter: ScheduleFilter | null;
}

export function matchesSearch(lead: LeadResponse, term: string): boolean {
    if (!term) return true;

    const normalized = term.trim().toLowerCase();

    return lead.contactName.toLowerCase().includes(normalized);
}

export function hasLeadFilters(filters: LeadFilters): boolean {
    return Boolean(filters.searchTerm)
        || filters.statusFilterId !== null
        || filters.ownerFilter !== null
        || filters.tagFilter !== null
        || filters.scheduleFilter !== null;
}

/// Lead aberto visível com os filtros atuais; regra única para card e contadores, senão divergem.
export function matchesLeadFilters(lead: LeadResponse, filters: LeadFilters): boolean {
    return matchesSearch(lead, filters.searchTerm)
        && (filters.statusFilterId === null || lead.statusId === filters.statusFilterId)
        && matchesOwner(lead.assignedUserId, filters.ownerFilter)
        && matchesTag(lead.tags, filters.tagFilter)
        && matchesScheduleFilter(lead.nextScheduledAt, filters.scheduleFilter);
}

/// Encerrado visível: busca, status, responsável e tag valem; o filtro de agenda esconde todos.
export function matchesClosedLeadFilters(lead: LeadResponse, filters: LeadFilters): boolean {
    return filters.scheduleFilter === null
        && matchesSearch(lead, filters.searchTerm)
        && (filters.statusFilterId === null || lead.statusId === filters.statusFilterId)
        && matchesOwner(lead.assignedUserId, filters.ownerFilter)
        && matchesTag(lead.tags, filters.tagFilter);
}

export function countVisibleLeads(columns: BoardColumnWithLeads[], filters: LeadFilters): number {
    return columns.reduce(
        (total, column) => total + column.leads.filter((lead) => matchesLeadFilters(lead, filters)).length,
        0);
}

/// Leads visíveis por status, sem o filtro de status: com ele, os outros chips mostrariam zero.
export function countVisibleByStatus(columns: BoardColumnWithLeads[], filters: LeadFilters): Map<string, number> {
    const counts = new Map<string, number>();
    const others: LeadFilters = { ...filters, statusFilterId: null };

    columns.forEach((column) => column.leads
        .filter((lead) => matchesLeadFilters(lead, others))
        .forEach((lead) => counts.set(lead.statusId, (counts.get(lead.statusId) ?? 0) + 1)));

    return counts;
}
